import flagDE from '../assets/flags/flag_de.png';
import flagEN from '../assets/flags/flag_en.png';
import flagNL from '../assets/flags/flag_nl.png';
import flagUK from '../assets/flags/flag_uk.svg';
import flagFR from '../assets/flags/flag_fr.svg';
import flagIT from '../assets/flags/flag_it.svg';
import flagES from '../assets/flags/flag_es.svg';
import flagSV from '../assets/flags/flag_sv.svg';
import flagFI from '../assets/flags/flag_fi.svg';
import flagJA from '../assets/flags/flag_ja.svg';
import flagPL from '../assets/flags/flag_pl.svg';
import flagBG from '../assets/flags/flag_bg.svg';

export const defaultLanguage = 'en';

export const supportedLanguages = [
  { code: 'de', flag: flagDE },
  { code: 'en', flag: flagEN },
  { code: 'nl', flag: flagNL },
  { code: 'uk', flag: flagUK },
  { code: 'fr', flag: flagFR },
  { code: 'it', flag: flagIT },
  { code: 'es', flag: flagES },
  { code: 'sv', flag: flagSV },
  { code: 'fi', flag: flagFI },
  { code: 'ja', flag: flagJA },
  { code: 'pl', flag: flagPL },
  { code: 'bg', flag: flagBG }
];

export const supportedLanguageCodes = supportedLanguages.map(({ code }) => code);

export const normalizeLanguageCode = (language) => {
  if (!language || typeof language !== 'string') return null;

  const primaryCode = language.toLowerCase().split(/[-_]/)[0];
  return supportedLanguageCodes.includes(primaryCode) ? primaryCode : null;
};

export const detectBrowserLanguage = () => {
  if (typeof navigator === 'undefined') return defaultLanguage;

  const browserLanguages = Array.isArray(navigator.languages) ? navigator.languages : [];
  const candidates = [...browserLanguages, navigator.language].filter(Boolean);

  for (const candidate of candidates) {
    const normalized = normalizeLanguageCode(candidate);
    if (normalized) return normalized;
  }

  return defaultLanguage;
};
